$ = jQuery;

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top > window.innerHeight - 100 ||
        rect.bottom < 100
    );
}

function isIntersecting(){
    var isTouching = 'no',
    theSidenav = $('.sidebar-components'),
    sideTop = theSidenav.offset().top,
    sideBottom = sideTop + theSidenav.outerHeight();
    
    
    $('.full-width-section, footer').each(function(){
        var
        elementTop = $(this).offset().top,
        elementBottom = elementTop + $(this).outerHeight();

        if(
            (sideTop > elementTop && sideTop < elementBottom) ||
            (sideBottom > elementTop && sideBottom < elementBottom)
        ){
            isTouching = 'yes';
        }
    });

    if(isTouching == 'yes'){
        $('.sidebar-components').css({
            opacity: 0,
            visibility: 'hidden'
        });
    } else {
        $('.sidebar-components').css({
            opacity: 1,
            visibility: 'visible'
        });
    }
}

(function($) {

    if(navigator.userAgent.indexOf('Chrome') !== -1){
        $('body').addClass('is-chrome');
    }

})( jQuery );
